import { mt } from "../../../../date-fns/locale/mt.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    mt
  }
};